import React from "react";
import { MouseEvent } from "react";
import { Icon } from "../Common/Icons/LucideIcons";
import { ActiveFloodLayerBadge, LegendControl } from "./__styles__/FullPageMap";
import { LegendControlContainer } from "./__styles__/FullPageMap";

interface LegendControlProps {
  activeFloodLayerName?: string;
  handleLayersToggle?: (evt: MouseEvent | KeyboardEvent) => void;
}

export const LegendControlTool = ({
  activeFloodLayerName,
  handleLayersToggle,
}: LegendControlProps) => {
  return (
    <LegendControlContainer>
      {activeFloodLayerName && (
        <ActiveFloodLayerBadge onClick={handleLayersToggle}>
          {activeFloodLayerName}
        </ActiveFloodLayerBadge>
      )}
      <LegendControl
        data-testid="legendControl"
        styleVariant="outlineLight"
        onClick={handleLayersToggle}
        aria-label="Toggle Map Layers panel"
      >
        <Icon iconName="layers" color="contentPrimary" size={16} />
      </LegendControl>
    </LegendControlContainer>
  );
};
